// extracted by mini-css-extract-plugin
export default {"mainArea":"HomePage_mainArea__bSiYN","mainContainer":"HomePage_mainContainer__80pAB","button":"HomePage_button__jZz07"};